import * as React from "react";
import {
  Card,
  DatePicker,
  type DatePickerHandle,
  PickerContainer,
  Table,
  Text,
  TextField,
} from "../../components";
import type { ManageBookingsViewModel } from "./viewModel";
import { ManageBookingsTableSkeleton } from "./ManageBookingsTableSkeleton";
import { Tools } from "../../utils";

export function View({ t, ...props }: ManageBookingsViewModel) {
  const dateRangePopoverRef = React.useRef<DatePickerHandle | null>(null);

  return (
    <div>
      <div className="bg-secondary px-[16px] lg:px-[80px] py-[20px] shadow-soft">
        <div className="grid gap-[20px] md:grid-cols-2 md:items-end">
          <TextField
            value={props.searchString}
            variant="surface"
            label={t("manageBookings.filters.search")}
            placeholder={t("manageBookings.filters.searchPlaceholder")}
            onChange={({ target }) =>
              props.setFilter("searchString", target.value)
            }
          />
          <div className="relative">
            <PickerContainer
              placeholder={t("manageBookings.filters.dateRangePlaceholder")}
              onClick={() => dateRangePopoverRef.current?.open()}
              label={t("dashboard.filters.dateRange")}
              value={Tools.formatDateRange(
                props.dateRange.from,
                props.dateRange.to,
              )}
            />
            <DatePicker ref={dateRangePopoverRef}>
              <DatePicker.Range
                clear
                value={props.dateRange}
                onChange={(v) => props.setFilter("dateRange", v)}
              />
            </DatePicker>
          </div>
        </div>
      </div>
      <Card className="mt-[16px] mb-[30px] mx-[16px]">
        {props.showSkeleton ? (
          <ManageBookingsTableSkeleton />
        ) : props.showGlobalEmpty ? (
          <Text className="text-center">{t("manageBookings.empty")}</Text>
        ) : (
          <>
            <Text level={2}>{t("manageBookings.title")}</Text>
            <Table
              className="mt-[16px]"
              loading={props.loading}
              columns={props.columns}
              dataSource={props.dataSource}
              sorter={props.tableSorter}
              rowKey={(row) => row.id}
              onRowClick={props.onRowClick}
              onChange={props.onTableChange}
              locale={{ emptyText: t("manageBookings.empty") }}
              pagination={{
                page: props.page,
                pageSize: props.pageSize,
                totalItems: props.totalItems,
                onPageChange: props.onPageChange,
                onPageSizeChange: props.onPageSizeChange,
              }}
            />
          </>
        )}
      </Card>
    </div>
  );
}
